var _rect, _path;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgMenu = function SvgMenu(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 11.5,
    fill: "white",
    stroke: "#F2F0F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6357 13.0909C10.6357 12.639 11.0021 12.2727 11.4539 12.2727H24.5448C24.9967 12.2727 25.363 12.639 25.363 13.0909C25.363 13.5428 24.9967 13.9091 24.5448 13.9091H11.4539C11.0021 13.9091 10.6357 13.5428 10.6357 13.0909ZM10.6357 18C10.6357 17.5481 11.0021 17.1818 11.4539 17.1818H24.5448C24.9967 17.1818 25.363 17.5481 25.363 18C25.363 18.4519 24.9967 18.8182 24.5448 18.8182H11.4539C11.0021 18.8182 10.6357 18.4519 10.6357 18ZM10.6357 22.9091C10.6357 22.4572 11.0021 22.0909 11.4539 22.0909H24.5448C24.9967 22.0909 25.363 22.4572 25.363 22.9091C25.363 23.361 24.9967 23.7273 24.5448 23.7273H11.4539C11.0021 23.7273 10.6357 23.361 10.6357 22.9091Z",
    fill: "#0500FF"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMenu, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/menu.5f52fb6f.svg";
export { ForwardRef as ReactComponent };